import { TextField } from "@mui/material";
import { useContext, useState } from "react";
//Import from project
import useCheckStudentHomework from "../../../Hooks/useCheckStudentHomework";

export default function ExerciseHomework({ editData, setRefetch }) {
  const { handleSubmit } = useCheckStudentHomework({ setRefetch });
  const [value, setValue] = useState(editData?.exercise || "");

  const handleChange = ({ target }) => {
    const value = target.value || "";
    if (value !== editData?.exercise) {
      console.log("handleSubmit :", {
        id: editData?._id,
        exercise: value || "",
      });
      handleSubmit({
        id: editData?._id,
        exercise: value || "",
      });
    }
  };

  return (
    <TextField
      fullWidth
      size="small"
      multiline
      sx={{
        ".css-12tl3rr-MuiInputBase-input-MuiOutlinedInput-input": {
          textAlign: "center",
          minWidth: 120,
        },
      }}
      className="text-field"
      placeholder={"--:--"}
      value={value}
      onBlur={handleChange}
      onChange={({ target }) => setValue(target?.value)}
    />
  );
}
